module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/maestro-4ffdb3def906b60d0e2fe005ab921aca.png";